
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iOsEl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $78789dd194b50e02$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $78789dd194b50e02$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': "\u3059\u3079\u3066\u306E\u30B5\u30A4\u30C8",
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': "\u9589\u3058\u308B",
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': "(\u73FE\u5728\u5229\u7528\u3067\u304D\u307E\u305B\u3093)"
};

});


//# sourceMappingURL=ja.3360bfa8.js.map
